import { connect } from 'react-redux';
import CustomConfirm from './CustomConfirm';

const mapStateToProps = (state: any) => ({
  name: state.confirmation.name,
  applyBtnAppearance: state.confirmation.applyBtnAppearance,
  applyBtnText: state.confirmation.applyBtnText,
  title: state.confirmation.title,
  onSubmit: state.confirmation.onSubmit,
  onCancel: state.confirmation.onCancel,
  onError: state.confirmation.onError,
  asyncAction: state.confirmation.asyncAction,
});

export default connect(mapStateToProps, null)(CustomConfirm);
